module.exports = __webpack_public_path__ + "img/bg3.7a7004d2.png";